import { useEffect } from "react";

import { useQuery } from "@tanstack/react-query";

import FastAPI from "../../api/FastAPI";
import useFAST from "../../contexts/FASTContext";

import type { UseQueryResult } from "@tanstack/react-query";

import type { GetSchedulesResponse } from "../../api/FastAPI.types";

interface UseGetSchedulesQueryParams {
  channelId: string;
}

function useGetSchedulesQuery({
  channelId,
}: UseGetSchedulesQueryParams): UseQueryResult<GetSchedulesResponse> {
  const { dispatch, state } = useFAST();

  const { timelineScheduleSelected } = state;

  const getSchedulesQuery = FastAPI.generateQuery({
    fn: FastAPI.getSchedules,
    params: [
      {
        channelId,
      },
    ],
  });

  const result = useQuery({
    ...getSchedulesQuery,
    enabled: Boolean(channelId),
  });

  const { data: schedules } = result;

  useEffect(() => {
    if (schedules?.data) {
      const defaultSchedule = schedules.data.find(
        (schedule) => schedule.default,
      );

      const isInSchedules = schedules.data.some(
        (schedule) => schedule.uuid === timelineScheduleSelected,
      );

      if (!isInSchedules || !timelineScheduleSelected) {
        dispatch({
          type: "SET_ACTIVE_SCHEDULE",
          id: defaultSchedule ? defaultSchedule.uuid : null,
        });
      }

      const sortedSchedules = schedules.data.sort(
        (a, b) => Number(b.default) - Number(a.default),
      );

      dispatch({
        type: "SET_SCHEDULES",
        schedules: sortedSchedules,
      });
    }
  }, [dispatch, schedules?.data, timelineScheduleSelected]);

  return result;
}

export default useGetSchedulesQuery;
